import React, { ReactElement } from 'react';
import QuestionSchema from '@ax2/common/model/schemas/QuestionSchema';
import { QuestionPreviewContent } from 'components/question-builders/QuestionPreviewContent';
import { ScreenerPreviewContent } from 'components/question-builders/ScreenerPreviewContent';
import { getTemplateText } from '@ax2/common/helpers/template';
import ScreenerQuestionSchema from '@ax2/common/model/schemas/ScreenerQuestionSchema';

export function getQuestionPreview(schema: QuestionSchema): ReactElement {
  const questionText =
    'content' in schema ? getTemplateText(schema.content) : null;
  return React.createElement(QuestionPreviewContent, {
    questionText: questionText,
    questionType: schema.questionType,
  });
}

export function getScreenerPreview(
  schema: ScreenerQuestionSchema
): ReactElement {
  const questionText =
    'content' in schema ? getTemplateText(schema.content) : null;
  return React.createElement(ScreenerPreviewContent, {
    ...schema,
    ...{
      questionText: questionText,
    },
  });
}
